// Do not import directly. Use with getRouter() and setRouter() only.
import { Router } from './Router.ts';

export const routerManager: { router?: Router } = {
  router: undefined
};